import { useEffect } from 'react';

const useFloatingEffect = (containerRef, sensitivity = 0.03) => {
    useEffect(() => {
        const element = containerRef.current;
        if (!element) return;

        const rect = element.getBoundingClientRect();
        const centerX = rect.left + element.offsetWidth / 2;
        const centerY = rect.top + element.offsetHeight / 2;

        let frameId = null;

        const handleMouseMove = (e) => {
            if (frameId) return;

            frameId = requestAnimationFrame(() => {
                const relX = (e.pageX - centerX) * sensitivity;
                const relY = (e.pageY - centerY) * -1 * sensitivity;

                element.style.transform =
                    `translateY(${relX}px) translateX(${relY}px)`;

                frameId = null;
            });
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, [containerRef, sensitivity]);
};

export default useFloatingEffect;